import { render, staticRenderFns } from "./TheProductCustomizerComplement.vue?vue&type=template&id=6f19ecb4&"
import script from "./TheProductCustomizerComplement.vue?vue&type=script&lang=js&"
export * from "./TheProductCustomizerComplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f19ecb4')) {
      api.createRecord('6f19ecb4', component.options)
    } else {
      api.reload('6f19ecb4', component.options)
    }
    module.hot.accept("./TheProductCustomizerComplement.vue?vue&type=template&id=6f19ecb4&", function () {
      api.rerender('6f19ecb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/customizer/TheProductCustomizerComplement.vue"
export default component.exports